import { createFeatureSelector, createSelector } from '@ngrx/store';
import { ResaleInvoiceDeliveryReducer } from '../reducers';

export const selectResaleInvoiceDeliveryFeature = createFeatureSelector<ResaleInvoiceDeliveryReducer.DataState>(ResaleInvoiceDeliveryReducer.featureName);

export const selectFeatureResaleInvoiceDelivery = createSelector(selectResaleInvoiceDeliveryFeature, (state: ResaleInvoiceDeliveryReducer.DataState) => state.detail);
